module.exports = "The SvgIcon component takes an SVG `path` element as its child; converting it to a React component which displays the path. This component also enables the icon to be styled and respond to mouse events. SvgIcon components are always squares, so setting the width will also set the same value as the height.\r\n\r\n## VersionOne Icons\r\nVersionOne UI also includes icons used by VersionOne. Each of these icons is its own component. More information on these icons can be found on the [Icons' page](#/page/icons).\r\n"


//////////////////
// WEBPACK FOOTER
// ../src/SvgIcon/README.md
// module id = 1625
// module chunks = 0